import { axiosPost } from '@/api/handlers';
import { useMutation } from '@/api/hooks';
import { useInvalidateQuery } from '@/hooks';
import { invalidateListMap } from '../review-sheet/utils/query-keys';

type RequestParams = {
  projectId: string;
  subProjectId: string;
  expenditureCartId: string;
  amount: number | null;
};

export const useUpsertExecutionItem = () => {
  const { invalidate } = useInvalidateQuery();
  return useMutation({
    mutationFn: async (params: RequestParams) => {
      const { projectId, subProjectId, expenditureCartId, amount } = params;
      const res = await axiosPost(
        `/api/projects/${projectId}/sub-projects/${subProjectId}/expenditure-carts/${expenditureCartId}/execution-item/`,
        { amount, name: '-', skipLock: true },
      );
      await Promise.all(
        invalidateListMap
          .updateDetailedBreakdown(projectId)
          .map(async (invalidateList) => {
            await invalidate(invalidateList);
          }),
      );
      return res;
    },
  });
};
